<template>
    <div class="flex">
      <div class="flexLeft">
        <div style="height: 100%">
          <!-- <img style="height: 96%;" src="../../assets/img/usp/loginLeft.png" /> -->
        </div>
      </div>
      <div class="flexRight">
      </div>
      <div class="loginDiv">
        <div v-if="!isSuccess" style="padding: 80px;">
           <el-form
            ref="registerFormRef"
            class="content"
            :model="form"
            label-width="80px"
            label-position="left"
          >
            <div style="text-align: center;paddingTop: 20px; paddingBottom: 55px">
              <img align="middle" style="width: 174px; height: 50px" src="../../assets/img/usp/logo.png" />
            </div>
            <div class="title">企业用户或高校用户注册</div>
            <div class="directions">选择自己的邮箱，开始注册吧。UAES用户无需第三步设置密码<br/></div>
            <el-steps class="steps" :active= stepActive align-center finish-status="success">
                <el-step title="选择邮箱"></el-step>
                <el-step title="设置用户邮箱"></el-step>
                <el-step title="设置密码"></el-step>
            </el-steps>
            <div class="carousel">
                <el-carousel ref="carousel" height="320px" :autoplay="false" indicator-position="none" arrow="never" :loop="false">
                    <el-carousel-item :key="1">
                      <div>
                        <el-row class="radioList">
                          <el-col class="radioListView" :span="8" :offset="4">
                            <div class="radioTitle"><i class="el-icon-share"></i> 企业用户</div>
                            <div class="radioListCellView">
                              <el-radio-group  v-model="emailForm.relationEnterprise" @change="radioChage($event)">
                                <el-radio class="radioCell" v-for="item in companyRadioList" :label="item.id" :key="item.suffix">{{ item.suffix }}&nbsp;{{ item.name }}</el-radio>
                              </el-radio-group>
                            </div>
                          </el-col>
                          <el-col class="radioListView" :span="8" :offset="3">
                            <div class="radioTitle"><i class="el-icon-s-data"></i> 高校用户</div>
                            <div class="radioListCellView">
                              <el-radio-group  v-model="emailForm.relationEnterprise" @change="collegeRadioChage($event)">
                                <el-radio class="radioCell" v-for="item in collegeRadioList" :label="item.id" :key="item.suffix">{{ item.suffix }}&nbsp;{{ item.name }}</el-radio>
                              </el-radio-group>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row style="text-align: center">
                          <el-checkbox v-model="checkAgreement" size="medium">
                            我已完全阅读并同意
                            <el-button type="text" @click="goDevProtocol">联电开发者服务协议</el-button>
                            及
                            <el-button type="text" @click="goPrivacyProtocol" style="margin-left: 0">隐私政策</el-button>
                          </el-checkbox>
                        </el-row>
                        <div style="width: 100%;text-align: center;">
                          <el-button class="firstStepButton" @click="firstStepClick()" :disabled="!checkAgreement">下一步</el-button>
                        </div>
                      </div>
                    </el-carousel-item>
                    <el-carousel-item class="carouselItem" :key="2">
                        <el-form :model="emailForm" status-icon :rules="rules" ref="emailForm" label-width="100px" :label-position="right" class="emailForm">
                          <el-form-item label="注册邮箱" prop="email">
                            <el-input type="text" v-model.trim="emailForm.email" @change="emailChangeFun" autocomplete="off" placeholder="请输入注册邮箱">
                             <template slot="append"><span class="appendText">{{ emailForm.relationEnterpriseAddress }}</span></template>
                            </el-input>
                          </el-form-item>
                          <el-form-item label="输入验证码" prop="checkPass">
                            <el-input maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" v-model="emailForm.verCode" autocomplete="off" placeholder="请输入验证码">
                              <el-button slot="append" style="height: 56px;border: none;padding: 0;width: 158px;">
                                <CountDown :urlType="7" v-show="showCount" :isPhone="false" :email="emailForm.email" :form="emailForm" @handleClick="clickBtn" :countdownStyle="countdownStyle" />
                              </el-button>
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <el-button class="secondStepButton" :disabled="!canSubmit" @click="secondStepClick()">下一步</el-button>
                    </el-carousel-item>
                    <el-carousel-item class="carouselItem" :key="3">
                      <el-form :model="emailPassWordForm" status-icon :rules="passWordRules" ref="emailPassWordForm" label-width="100px" :label-position="right" class="emailForm">
                        <el-form-item label="登录密码" prop="firstEmailPassword">
                          <el-input type="password" v-model.trim="emailPassWordForm.firstEmailPassword" @change="firstEmailPasswordChange()" autocomplete="off" show-password placeholder="请输入登录密码"></el-input>
                        </el-form-item>
                        <el-form-item label="重复登录密码" prop="secondEmailPassword">
                          <el-input type="password" v-model.trim="emailPassWordForm.secondEmailPassword" autocomplete="off" show-password placeholder="请输入登录密码"></el-input>
                        </el-form-item>
                      </el-form>
                        <el-button class="registerButton" @click="registerClick('emailPassWordForm')">注册</el-button>
                    </el-carousel-item>
                </el-carousel>
            </div>
          </el-form>
        </div>
        <div v-else  style="padding: 80px;">
          <div style="text-align: center;paddingTop: 20px;">
            <img align="middle" style="width: 174px; height: 50px" src="../../assets/img/usp/logo.png" />
          </div>
          <div style="text-align: center;paddingTop: 42px">
            <img align="middle" style="width: 180px; height: 180px" src="../../assets/img/usp/loginWasSuccessful.png" />
          </div>
          <div class="welcomeTittle">
            注册成功
          </div>
          <div class="welcomeMessage">
            欢迎加入，赶快登录，开启你的USP之旅吧~
          </div>
           <div style="width: 100%;text-align: center;padding-top:200px">
              <el-button class="firstStepButton" @click="signInNow()">立即登录</el-button>
            </div>
        </div>
      </div>
      <el-dialog
        title=""
        :visible.sync="dialogDevProtocolVisible"
        fullscreen="true"
        lock-scroll="true"
        height="100%"
      >
        <div style="height:auto;" v-loading="dialogLoading">
          <iframe id="devProtocol" src="https://usp-test.uaes.com/devProtocol.html" frameborder="0" width="100%" style="height: 90vh"></iframe>
        </div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogPrivacyProtocolVisible"
        fullscreen="true"
        lock-scroll="true"
        height="100%"
      >
        <div style="height:auto;" v-loading="dialogLoading">
          <iframe id="privacyProtocol" src="https://usp-test.uaes.com/privacyProtocol.html" frameborder="0" width="100%" style="height: 90vh"></iframe>
        </div>
      </el-dialog>
    </div>
  </template>

<script>
import { remoteLoad } from '@/scripts/captcha'
import { mapGetters } from 'vuex'
import { getUserInfo } from '@/api/modules/iam'
import CountDown from '@/components/CountDown.vue'
import store from '@/store/index'
import { emailRegByCode, emailRegByPassword } from '@/api/modules/iam'
import { getCooperatorList } from '@/api/modules/uaes'
import { getPasswordRSAV } from '@/scripts/utils'
export default {
  name: 'CompanyReg',
  components: {
    CountDown
  },
  data() {
    var validatePass = (rule, value, callback) => {
      const res = /^(?=.*[a-zA-Z])(?=.*\d).{6,12}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      else {
        if (this.emailPassWordForm.secondEmailPassword !== '') {
          this.$refs.emailPassWordForm.validateField('secondEmailPassword')
        }
        if (!res.test(value)) {
          callback(new Error(' 至少包含字母、数字，6-12位'))
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      else if (value !== this.emailPassWordForm.firstEmailPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      else {
        callback()
      }
    }
    return {
      stepActive: '1',
      inited: false,
      activeIndex: '1',
      getCodeClass: 'normalButton',
      radio: '1',
      companyRadioList: [
      ],
      collegeRadioList: [
      ],
      emailForm: {
        email: '',
        verCode: '',
        relationEnterprise: '',
        relationEnterpriseName: '',
        relationEnterpriseAddress: ''
      },
      emailPassWordForm: {
        firstEmailPassword: '',
        secondEmailPassword: ''
      },
      canSubmit: false,
      countdownStyle: {
        background: '#DDDDDD',
        color: '#FFFFFF',
        height: '56px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      showCount: true,
      passWordRules: {
        firstEmailPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        secondEmailPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      isSuccess: false,
      checkAgreement: false,
      dialogDevProtocolVisible: false,
      dialogPrivacyProtocolVisible: false,
      dialogLoading: true
    }
  },
  computed: {
    ...mapGetters({
      // userInfo: 'userAuth/getUsersCurrentInfo'
    })
  },
  watch: {
    async $route(_to, _from) {
      if (!this.inited) {
        await this.init()
      }
    }
  },
  async created() {
    await this.init()
    const res = await getCooperatorList({ type: 0 })
    if (res.code === 0) {
      this.companyRadioList = res.data
    }
    const collegeRes = await getCooperatorList({ type: 1 })
    if (collegeRes.code === 0) {
      this.collegeRadioList = collegeRes.data
    }
  },
  methods: {
    signInNow() {
      this.$router.replace('/login')
    },
    firstEmailPasswordChange(e) {
      console.log(e)
    },
    radioChage(e) {
      const companyRadioList = this.companyRadioList
      var index = companyRadioList.findIndex((item) => item.id === e)
      this.emailForm.relationEnterprise = e
      this.emailForm.relationEnterpriseName = companyRadioList[index].name
      this.emailForm.relationEnterpriseAddress = companyRadioList[index].suffix
    },
    collegeRadioChage(e) {
      const collegeRadioList = this.collegeRadioList
      var index = collegeRadioList.findIndex((item) => item.id === e)
      this.emailForm.relationEnterprise = e
      this.emailForm.relationEnterpriseName = collegeRadioList[index].name
      this.emailForm.relationEnterpriseAddress = collegeRadioList[index].suffix
    },
    clickBtn(status) {
      this.canSubmit = status
    },
    handleSelect(e) {
      this.activeIndex = e.name
      console.log(e.name)
    },
    emailChangeFun(value) {
      if (value.length > 0) {
        this.getCodeClass = 'usableButton'
      }
      else {
        this.getCodeClass = 'normalButton'
      }
    },
    firstStepClick() {
      if (!this.emailForm.relationEnterprise) {
        this.$message({
          message: '请选择您要注册的合作企业或者高校邮箱。',
          type: 'warning'
        })
        return false
      }
      this.stepActive = '2'
      this.$refs.carousel.next()
    },
    async secondStepClick() {
      const res = await emailRegByCode({ email: this.emailForm.email + this.emailForm.relationEnterpriseAddress, code: this.emailForm.verCode })
      if (res.code === 0) {
        if (this.emailForm.relationEnterpriseAddress === '@uaes.com') {
          this.$refs['emailPassWordForm'].resetFields()
          this.isSuccess = true
        }
        else {
          this.stepActive = '3'
          this.$refs.carousel.next()
        }
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    registerClick(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.emailRegByPassword(formName)
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async emailRegByPassword(formName) {
      const res = await emailRegByPassword({
        email: this.emailForm.email + this.emailForm.relationEnterpriseAddress,
        password: getPasswordRSAV(this.emailPassWordForm.firstEmailPassword),
        relationEnterprise: this.emailForm.relationEnterprise
      })
      console.log(res)
      if (res.code === 0) {
        this.$refs[formName].resetFields()
        this.isSuccess = true
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    async init() {
      setTimeout(() => {
        remoteLoad('https://turing.captcha.qcloud.com/TCaptcha.js')
      }, 10)
      this.inited = true
    },
    async userInfo() {
      const res = await getUserInfo()
      if (res.code === 0) {
        store.commit('userAuth/usersCurrentInfo', res.data)
        // localStorage.setItem('userInfo', JSON.stringify(res.data))
        this.$router.push('/uc')
      }
    },
    goDevProtocol() {
      this.dialogLoading = true
      this.dialogDevProtocolVisible = true
      setTimeout(() => {
        this.dialogLoading = false
      }, 2000)
      setTimeout(function() {
        /**
         * iframe-宽高自适应显示
         */
        const oIframe = document.getElementById('devProtocol')
        const deviceWidth = document.documentElement.clientWidth
        const deviceHeight = document.documentElement.clientHeight
        // 数字是页面布局宽度差值
        oIframe.style.width = Number(deviceWidth)
        // 数字是页面布局高度差
        oIframe.style.height = Number(deviceHeight) - 120 + 'px'
      }, 1000)
    },
    goPrivacyProtocol() {
      this.dialogLoading = true
      this.dialogPrivacyProtocolVisible = true
      setTimeout(() => {
        this.dialogLoading = false
      }, 2000)
      setTimeout(function() {
        /**
         * iframe-宽高自适应显示
         */
        const oIframe = document.getElementById('privacyProtocol')
        const deviceWidth = document.documentElement.clientWidth
        const deviceHeight = document.documentElement.clientHeight
        // 数字是页面布局宽度差值
        oIframe.style.width = Number(deviceWidth)
        // 数字是页面布局高度差
        oIframe.style.height = Number(deviceHeight) - 120 + 'px'
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
  body{
    width:100%;
    height:100%;
  }
    .flex{
      display: flex
    }
    .flexLeft{
      width: calc(100vw * 0.71);
      height: 100vh;
      position: relative;
    }
    .flexRight{
      background-color: #4d78ff;
      width: calc(100vw * 0.29);
      height: 100vh;
    }
    .loginDiv{
      position: absolute;
      left: calc(100vw * 0.5 - 600px);
      align-self: center;
      background: #FFFFFF;
      box-shadow: 0px 17px 28px 4px rgba(0,127,243,0.09);
      border-radius: 4px;
      min-height: 832px;
      min-width: 1200px;
    }
    .title{
        text-align: center;
        font-size: 24px;
        color: #4d78ff;
        font-family:"微软雅黑";
        font-weight: 400;
    }
    .directions{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
    }
    .steps{
        margin-top: 32px;
    }
    ::v-deep .el-step__head.is-success {
        color: #4d78ff;
        border-color: #4d78ff;
    }
    ::v-deep .el-step__title.is-success {
        font-weight: bold;
        color: #4d78ff;
    }
    ::v-deep .el-step__description.is-success {
        color: #4d78ff;
    }
    ::v-deep .el-step__head.is-success .el-step__icon{
      color: #ffffff;
      background: #4d78ff;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
  }
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .carouselItem{
    // width: 500px;
    // padding-left: 250px;
    width: 600px;
    padding-left: 230px;
    text-align: center;
  }
  .carousel{
    margin-top: 60px;
  }
  .firstStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .secondStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .registerButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .appendText{
    font-size: 14px;
    font-weight: 400;
    color: #2F374B;
  }
  .normalButton{
    background: #DBDBDB !important;
    border: 1px solid #DBDBDB !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .usableButton{
    background: #003A6F !important;
    border: 1px solid #003A6F !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .radioList{
    height: 160px;
  }
  .radioListView{
    height: 160px;
  }
  .radioTitle{
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: #838383;
  }
  .radioListCellView{
    margin-top: 20px;
    height: 110px;
    overflow-y: auto;
  }
  .radioCell{
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #838383;
  }
  ::v-deep .el-input__inner {
    height:56px
  }
  ::v-deep .el-form-item__label{
    width: 120px !important;
  }
  ::v-deep .el-form-item__content{
    margin-left: 120px !important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #4d78ff !important;
    background: #4d78ff !important;
  }
  ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #4d78ff !important;
  }
  .el-icon-share {
    background: url('../../assets/img/usp/enterprise.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-share:before {
    content: "11";
    visibility: hidden;
  }
  .el-icon-s-data {
    background: url('../../assets/img/usp/college.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-s-data:before {
    content: "11";
    visibility: hidden;
  }
  .countdown .getNumber{
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF !important;
      background: #4d78ff !important;
  }
  ::v-deep .el-step__icon{
    width: 38px;
    height: 38px;
  }
  ::v-deep .el-step.is-horizontal .el-step__line{
    top: 17px;
  }
  .welcomeTittle{
    height: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #2F374B;
    text-align: center;
    padding-top: 20px;
  }
  .welcomeMessage{
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
    text-align: center;
    padding-top: 20px;
  }
  .el-button.is-disabled:hover {
    color: #FFF;
    background-color: #a0cfff;
    border-color: #a0cfff;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 15px;
    right: 15px;
    font-size: 30px;
  }
</style>
